import MicroModal from 'micromodal';
import serializeArray from './_serializeArray'
import error from './_error'

(() => {
  if(typeof Stripe == 'undefined') return false;

  MicroModal.init();

  const is_debug = (
    location.hostname === "kisofukushima-ski.lc"
  ) ?
    true : false;

  const is_staging = (
    location.hostname === "kisofukushima-ski.planpotdesignworks.com"
  ) ?
    true : false;

  const key = (
    is_debug || is_staging
  ) ?
    'pk_test_51HMGXQH1rLY1ozumMKbT3s4xvMLhtRJdu8AqYxciU8bkclTEEFDNRxN0b93Y6bZhyGjmO4L7Pow2AKpoEPfVvyrG00Ful0D4LW':
    'pk_live_51HMGXQH1rLY1ozumfSmyIkwVYSjqUNKWx7nQtu5UWIHNok1yDq0fNdAL32lfF3EO8DMn2bFSTbOjg1WFTBaaEgF100aeuo3Fr2';

  const stripe = Stripe(key);
  const elements = stripe.elements();

  const payment = document.querySelector('.payment-form');
  const form = document.querySelector('.mw_wp_form > form');

  document.form_is_back = false;

  if(!form) return;

  const payment_type = form.querySelector('input[type="hidden"][name="お支払い方法"]');

  const card_number = elements.create('cardNumber');
  const card_expiry = elements.create('cardExpiry');
  const card_cvc = elements.create('cardCvc');

  if(payment_type){
    const send_button = form.querySelector('.send-button');
    const credit_button = form.querySelector('.credit-button');
    const fix_button = form.querySelector('.form-fix-button');
    const back_button = form.querySelector('.form-back-button');
    const setFormBack = (e) => { document.form_is_back = true };
    if(payment_type.value == 'クレジットカード'){
      send_button.classList.add('input_show');
    }else{
      credit_button.classList.add('input_show');
    }
    credit_button.addEventListener('click', (e) => {
      e.preventDefault();
      payment.classList.add('payment');
      MicroModal.show('payment-modal');
      card_number.mount('#card-number');
      card_expiry.mount('#card-expiry');
      card_cvc.mount('#card-cvc');
      return error.setEvent([card_number,card_expiry,card_cvc]);
    });
    fix_button.addEventListener('click', setFormBack);
    back_button.addEventListener('click', setFormBack);
  }

  form.addEventListener('submit', (e) => {
    const payment_choose = document.querySelector('input[type="hidden"][value="クレジットカード"]');
    enableInputs();
    if(
      !payment_choose ||
      form.parentElement.classList.contains('mw_wp_form_input') ||
      form.is_back === true
    ) return this;//form.onsubmit ? e.target.submit() : this;

    //payment submit
    e.preventDefault();
    payment.classList.add('submitting');
    disableInputs();
    const additionalData = serializeArray(form);
    stripe.createToken(card_number, additionalData)
      .then(function(result) {
        if(result.token){
          sendChargeRequest(payment, result, additionalData);
          return result;
        }
        if(result.error) error.showError(`${result.error.message}(${result.error.code}:${result.error.decline_code})`);
        payment.classList.remove('submitting');
        enableInputs();
      });
  });

  const sendChargeRequest = (payment, result, additionalData) => {

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '../../wp-content/themes/kisofukushima-ski/charge.php');
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onreadystatechange = () => {
      if(xhr.readyState === 4 && xhr.status === 200) {
        sendChargeRequestHandler(payment, xhr.responseText);
      }
    }
    additionalData.stripeToken = result.token.id;

    xhr.send(JSON.stringify(additionalData));
  }

  const sendChargeRequestHandler = (payment, responseText) => {
    if(responseText.match(/決済完了/)){
      payment.classList.remove('submitting');
      payment.classList.add('submitted');
      form.submit();
    }else{
      payment.classList.remove('submitting');
      error.showError(responseText);
      enableInputs();
    }
  }

  const enableInputs = () => {
    Array.prototype.forEach.call(
      form.querySelectorAll(
        "input[type='text'], input[type='email'], input[type='tel']"
      ),
      (input) => {
        input.removeAttribute('disabled');
      }
    );
  }

  const disableInputs = () => {
    Array.prototype.forEach.call(
      form.querySelectorAll(
        "input[type='text'], input[type='email'], input[type='tel']"
      ),
      (input) => {
        input.setAttribute('disabled', 'true');
      }
    );
  }


})()
